import React from "react";
import HelpMessage from "./HelpMessage";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  return (
    <div className="limiter">

      <div className="uds-login-wrapper">
        <div className="uds-login-banner">
          <img src={require("../Assets/Images/uds-hero.jpg")} alt="UDS Banner" className="w-100 img-fluid" />
        </div>
        <div className="uds-login-box w-100">
          <div className="uds-login-box-inner card affix">
            <Header />

            <div className="forgot-password-instructions">
              To reset your password please enter your email address or
              supplier id number below and you will be emailed further
              instructions
            </div>

            <div className="login-form-field">
              <label className="pd-25">Email or Supplier ID</label>
              <input
                className="input100 inputBg shadow"
                id="UserName"
                name="UserName"
                placeholder="Email or Supplier ID"
                type="text"
              />
              <span className="focus-input100" data-placeholder="Username" />
            </div>
            <span
              className="field-validation-valid text-danger"
              data-valmsg-replace="true"
            />
            <div className="container-login100-form-btn LoginButtonDiv forgot-password-btns">
              <button
                className="login100-form-btn"
                type="submit"
                value="Get Password"
              >
                <span>Get Password</span>
              </button>
              <button
                className="login100-form-btn"
                id="btnReturnToLogin"
                type="button"
                value="Return to Login"
                onClick={() => {
                  navigate("/");
                }}
              >
                <span>Return to Login</span>
              </button>
            </div>
            <HelpMessage />

          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
